import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import socialMedia from 'root/src/shared/constants/socialMedia';
import { DiscordIcon } from 'root/src/client/v2/common/components/icons/DiscordIcon';
import { WIDGET_Z_INDEX } from 'root/src/client/v2/layout/fixtures/layout.fixtures';
import { FLOATING_WIDGET_ICON_CLASS, FLOATING_WIDGET_RIGHT_CLASS, FLOATING_WIDGET_SIZE_CLASS, useDiscordWidgetBottom, } from 'root/src/client/v2/layout/hooks/floatingWidgetStack';
import { cn } from 'root/src/client/v2/common/helpers/cn';
// Floating "Join us on Discord" button, bottom-right (legacy DiscordWidget parity). Rendered by
// RedesignLayout on every redesign page unless the page opts out (e.g. the campaign wizard, whose
// sticky step nav owns the bottom edge). Anything else floating in that corner (the drop page's
// admin preview toggle) stacks above it, like the legacy widgets did.
//
// Portalled to <body>, like the Toaster and for the same reason: RedesignLayout is `isolate`, so a
// z-index set inside it can never lift anything above a fixed element rendered OUTSIDE that subtree.
// The legacy widgets `RenderModules` still mounts are exactly that, and the Drift chat bubble (pinned
// to z-index 1000 by app.css) was painting straight over this button. Out here it sits on the shared
// WIDGET_Z_INDEX layer those widgets use, still below modals and toasts.
export const RedesignDiscordWidget = () => {
    const bottom = useDiscordWidgetBottom();
    // SSR and first paint render nothing: `document` only exists once mounted on the client.
    const [mounted, setMounted] = useState(false);
    useEffect(() => {
        setMounted(true);
    }, []);
    if (!mounted) {
        return null;
    }
    // `.redesign` is the scope marker every redesign portal root carries (see app.css), kept here so the
    // button keeps the redesign tokens outside the layout subtree. It goes on a `contents` wrapper rather
    // than on the link itself: the `.redesign` rule sets `color` and would otherwise beat the link's own
    // `text-white` on the same element, since it is declared after Tailwind's utilities layer.
    return createPortal(<div className="redesign contents">
			<a href={socialMedia.discord} target="_blank" rel="noreferrer" aria-label="Join us on Discord" title="Join us on Discord" style={{ zIndex: WIDGET_Z_INDEX, bottom }} className={cn('fixed flex items-center justify-center rounded-full bg-[#5865F2] text-white', 'no-underline shadow-2xl shadow-black/50 transition-transform hover:scale-105', FLOATING_WIDGET_SIZE_CLASS, FLOATING_WIDGET_RIGHT_CLASS)}>
				<DiscordIcon className={FLOATING_WIDGET_ICON_CLASS}/>
			</a>
		</div>, document.body);
};
